import React, { useState } from 'react';
import axios from 'axios';
import style from "../../../css/auth/Login.module.css";
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../ApiConfig';
import {getSecureToken} from '../../ApisService/apiService'


const Admin_login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    fullName: '',
    mobileNumber: '',
  });

  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState(''); // State for message
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleLogin = async (e) => {
    
        const { secrettoken, ts } = await getSecureToken();

    e.preventDefault();

    try {
      const response = await axios.post(
        `${API_BASE_URL}adminauth/admin_login.php`,
        {
          email: formData.email,
          password: formData.password,
          fullName: formData.fullName,
          mobileNumber: formData.mobileNumber,
        },
        {
          withCredentials: true,
            headers: {
                        'X-TOKEN': secrettoken,
                        'X-TIMESTAMP': ts
                    }
        }
      );

      if (response.status !== 200) {
        throw new Error(response.data.message || 'Login failed');
      }

      const data = response.data;
      setMessage("Login successful");

      // Store in localStorage if needed
      localStorage.setItem('userEmail', formData.email);
      localStorage.setItem('fullName', data.fullName);
      localStorage.setItem('mobilenumber', data.mobileNumber);
      localStorage.setItem('islogin', 'true');

      setFormData({ email: '', password: '' });

      setTimeout(() => {
        setMessage('');
      }, 1000);

      navigate('/admin_dash');

    } catch (error) {
      setMessage(`Login failed: ${error.response?.data?.message || error.message}`);
    }
  };



  return (
    <>
      <div className='container-fluid ' >
        <div className='container'>
          <div className="row py-1">
            <div className="col-md-6 d-flex justify-content-center">
              <img src="/images/Work time-bro.svg" alt="" style={{ maxWidth: '700px' }} className={`d-none d-md-block ${style.imganimationadmin}`} />
            </div>


            <div className={`${style.modelcontent_b} col-md-6`} style={{ background: 'transparent', alignContent: 'center' }}>

              <div className={`${style.loginmodalbox}  modal-body py-5`} style={{ border: '1px solid gray', borderRadius: '20px' }}>
                <h1 className={`${style.loginheading} top`}>Admin Login</h1>

                {message && <div className={style.message}>{message}</div>} {/* Display message */}

                <label className={style.logincontent} htmlFor="username">
                  User name
                  <div className={style.loginicons} style={{ border: '1px solid gray', borderRadius: '10px' }}>
                    <i className={`${style.loginIcons} fa-solid fa-at`}></i>
                    <input
                      className={style.loginmodalinputemail}
                      type="email"
                      placeholder="enter your email"
                      // id="username"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                    />
                  </div>
                </label>

                <label className={style.logincontent} htmlFor="password">
                  Password
                  <div className={style.loginicons} style={{ border: '1px solid gray', borderRadius: '10px' }}>
                    <i className={`${style.loginIcons} fa-solid fa-lock`}></i>
                    <input
                      className={style.loginmodalinputpass}
                      type={showPassword ? 'text' : 'password'}
                      placeholder="your password"
                      // id="password"
                      name="password"
                      value={formData.password}
                      onChange={handleInputChange}
                    />
                    <button
                      type="button"
                      onClick={togglePasswordVisibility}
                      className={style.showPasswordBtnlogin}
                    >
                      {showPassword ? <i className="fa-regular fa-eye-slash"></i> : <i className="fa-regular fa-eye"></i>}
                    </button>
                  </div>
                </label>

                <button
                  type="button"
                  className={`${style.loginmodalbtn} btn`}
                  onClick={handleLogin}

                >
                  Login
                </button>


              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Admin_login;
